// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2AKIU","errorLogs":"EditorFooter_errorLogs__3EU2a"};